export interface HotItem {
  id: string;
  tag: string;
  title: string;
  summary: string;
  image: string;
  readTime: string;
}

export const hotItems: HotItem[] = [
  {
    id: "wuhun",
    tag: "设定解析",
    title: "唐三双生武魂到底有多强？蓝银草与昊天锤的合击逻辑",
    summary: "蓝银草的坚韧控制与昊天锤的至刚至猛，双生武魂如何在大战中打出真正的压制力？一篇讲清双武魂的成长线。",
    image: "https://readdy.ai/api/search-image?query=Glowing%20blue%20vines%20and%20a%20massive%20ancient%20hammer%20floating%20side%20by%20side%2C%20chinese%20fantasy%20power%20symbols%2C%20warm%20amber%20and%20cream%20tones%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20clean%20composition%2C%20high%20detail&width=640&height=420&seq=hot-wuhun&orientation=landscape",
    readTime: "8分钟",
  },
  {
    id: "qigui",
    tag: "角色盘点",
    title: "史莱克七怪成长轨迹全盘点：从菜鸟到顶梁柱",
    summary: "戴沐白、奥斯卡、宁荣荣、马红俊……每一位七怪成员的起点、绝技与成长关键词，一次看够。",
    image: "https://readdy.ai/api/search-image?query=Seven%20distinct%20young%20warriors%20in%20different%20dynamic%20poses%20forming%20a%20power%20lineup%2C%20chinese%20fantasy%20academy%20students%2C%20warm%20autumn%20tone%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20high%20detail&width=640&height=420&seq=hot-qigui&orientation=landscape",
    readTime: "6分钟",
  },
  {
    id: "haichen",
    tag: "剧情解析",
    title: "海神九考到底考什么？每一考的艰难与深意",
    summary: "海神岛九考层层递进，考的是魂力更是心境。逐考拆解每一关背后的考验逻辑。",
    image: "https://readdy.ai/api/search-image?query=Golden%20god%20temple%20trial%20halls%20with%20nine%20glowing%20gates%20on%20a%20cliff%20by%20the%20sea%2C%20chinese%20fantasy%2C%20warm%20golden%20light%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20high%20detail&width=640&height=420&seq=hot-haichen&orientation=landscape",
    readTime: "7分钟",
  },
  {
    id: "wuhundian",
    tag: "剧情解析",
    title: "武魂殿为何是最终之战的最大对手？",
    summary: "势力盘根错节、野心膨胀，武魂殿的威胁如何一步步把故事推向高潮决战。",
    image: "https://readdy.ai/api/search-image?query=Foreboding%20ancient%20dark%20palace%20with%20golden%20emblems%20under%20a%20stormy%20red%20sky%2C%20chinese%20fantasy%20villain%20stronghold%2C%20dramatic%20warm%20lighting%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20high%20detail&width=640&height=420&seq=hot-wuhundian&orientation=landscape",
    readTime: "5分钟",
  },
  {
    id: "shijie",
    tag: "世界观",
    title: "斗罗大陆世界观与魂环体系，一篇讲明白",
    summary: "魂力、魂环、魂师等级、宗门与大陆格局，入门必读的世界观速览。",
    image: "https://readdy.ai/api/search-image?query=Floating%20rings%20of%20light%20spiraling%20around%20a%20heroic%20silhouette%20above%20a%20vast%20fantasy%20continent%2C%20chinese%20cultivation%20world%2C%20warm%20gold%20tones%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20high%20detail&width=640&height=420&seq=hot-shijie&orientation=landscape",
    readTime: "9分钟",
  },
  {
    id: "xiaowu",
    tag: "角色解读",
    title: "小舞十万年魂兽身份之谜：守护与宿命",
    summary: "从暗藏身份到为爱牺牲，小舞这条情感线的伏笔与爆发都藏在哪里？",
    image: "https://readdy.ai/api/search-image?query=Graceful%20moonlight%20rabbit%20spirit%20glowing%20beside%20a%20young%20woman%20in%20ancient%20robes%20under%20a%20full%20moon%2C%20chinese%20fantasy%2C%20warm%20silver%20and%20amber%20tone%2C%20ink%20wash%20mixed%20with%20vibrant%20color%2C%20high%20detail&width=640&height=420&seq=hot-xiaowu&orientation=landscape",
    readTime: "6分钟",
  },
];